import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Progress } from 'semantic-ui-react';
import AnalyticsSection from 'components/dashboard/analytics-content/AnalyticsSection';
import CommonPopup from 'components/common/CommonPopup';

import './UserEarnings.css';

const UserEarnings = ({
  balance = 0,
  thresholdSum = 100,
}) => {
  const thresholdBalance = balance.toFixed(2) / thresholdSum.toFixed(2) * thresholdSum;
  const { t } = useTranslation();

  return (
    <AnalyticsSection
      className="user-earnings-section__component"
      header={
        <div className="title">
          <h3>
            {t("Your earnings")}
            <CommonPopup
              questionIcon
              type="info"
            >
              {t("Once your balance reaches the threshold amount, you will hear from us. We will need the payment details, so we can transfer the earned balance to your account. Before making a transfer, we will need to validate if you generated the valid traffic on your page. In some cases, it might take up to 30 day.")}
            </CommonPopup>
          </h3>
        </div>
      }
    >
      <div className="user-earnings-section-content">
        <div className="user-earnings-header">
          <div className="user-earnings-header-wrapper">
            <span>{t("Paid monthly on demand if the total is at least")} ${thresholdSum.toFixed(2)} {t("(your payout threshold)")}</span>
            <b>${balance}</b>
          </div>
        </div>

        <div className="user-earnings-progress">
          <Progress percent={thresholdBalance} size="small" />
        </div>

        <div className="user-earnings-footer">
          <div className="user-earnings-footer-wrapper">
            <span>{t("You've reached")} {thresholdBalance.toFixed(0)}% {t("of your payment threshold")}</span>
            <span>{t("Payment threshold:")} ${thresholdSum.toFixed(2)}</span>
          </div>
        </div>
      </div>
    </AnalyticsSection>
  );
};

UserEarnings.propTypes = {
  balance: PropTypes.number.isRequired,
  thresholdSum: PropTypes.number.isRequired,
};

export default UserEarnings;
